import { store } from 'store'

import UserAnalyticsProperties from './UserAnalyticsProperties'
import amplitude from './amplitude'
import intercom from '../Intercom'
import branch from './branch'
import consumers from './consumers'

export const initAnalytics = () => {
  consumers.forEach((consumer) => consumer.init())
}

export const setAnalyticsUserProperties = () => {
  const state = store.getState()
  const provider = new UserAnalyticsProperties(state)
  const userProperties = provider.getUserProperties()
  consumers.forEach((consumer) => consumer.setUserProperties(userProperties, state))
}

export const sendAnalyticsEvent = (event, eventProperties = {}, amplitudeCallback = null) => {
  setAnalyticsUserProperties()
  amplitude.sendEvent(event, eventProperties, amplitudeCallback)
  intercom.sendEvent(event, eventProperties)
}

export const sendBranchEvent = branch.sendEvent
